<template>
  <div
    class="fit row items-center justify-center"
    style="position: relative; user-select: none"
  >
    <Loading
      style="position: fixed;z-index: 999"
      v-if="loading"
      text="正在获取样本列表"
    />
    <div
      v-else
      style="position: absolute; right: 10px; top: 10px; z-index: 2;"
      class="bmap-custom-marker-controller"
    >
      <div
        class="bmap-custom-marker-control"
        :class="{
          'bmap-custom-marker-control-active': selectedType === type.key_prefix,
        }"
        v-for="type in pointType"
        :key="type.key_prefix"
        @click="selectedType = type.key_prefix"
      >
        {{ type.label }}
      </div>
    </div>
    <div
      style="position: absolute; z-index: 1"
      id="_admin_sample_distribution"
      class="fit"
    ></div>

    <SampleAnalysis style="z-index: 999" />
  </div>
</template>

<script>
import { fetchSampleList } from "../../../api/endpoints/sample/fetchSampleList";
import BMapMixin from "../../../mixins/bmap.mixin";
import { setTimeout } from "timers";
export default {
  mixins: [BMapMixin],
  components: {
    Loading: () => import("@/components/Loading"),
    SampleAnalysis: () => import("./SampleAnalysis"),
  },

  data() {
    return {
      loading: false,
      samples: [],
      pointType: [
        { key_prefix: "dom", label: "注册地址" },
        { key_prefix: "addr", label: "经营地址" },
        { key_prefix: "entname", label: "地图检索地址" },
      ],
      selectedType: undefined,
      loadingText: "正在获取样本列表",
    };
  },

  created() {
    this.loading = true;
    this.loadingText = "正在获取样本列表";
  },
  mounted() {
    if (!this.selectedType) this.selectedType = "dom";
    setTimeout(() => {
      this.$nextTick(() => this.loadAllSamples());
    }, 0);
  },

  methods: {
    async loadAllSamples() {
      try {
        this.loading = true;
        this.loadingText = "正在获取样本列表";
        const response = await fetchSampleList([
          "name",
          "sample_id",
          "dom_lon",
          "dom_lat",
          "addr_lon",
          "addr_lat",
          "entname_lon",
          "entname_lat",
        ]);
        if (!response || response.status)
          throw Error(response.detail || response.message);
        this.samples = response;
        this.$nextTick(() => {
          this.renderMap();
        });
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: "获取样本列表时出现错误",
        });
      } finally {
        this.loading = false;
      }
    },

    async renderMap() {
      this.loading = true;
      this.loadingText = "正在渲染地图";

      await this.renderSamplesGroupByStatus(
        this.samples,
        this.selectedType,
        "_admin_sample_distribution",
        (pointCollection) => {}
      );
      this.loading = false;
    },
  },

  watch: {
    selectedType: {
      immediate: true,
      handler(type) {
        if (!type) return;
        this.renderMap();
      },
    },
  },
};
</script>
